import { applyTransparency, currencyFormat, generateBackgroundColor, message, sensurarEmail, sensurarString } from "../../utils/Funciones.js";
import { IoCart, IoDesktopSharp, IoFlashSharp, IoServer } from "react-icons/io5";
import { useEffect, useState, useMemo, useRef } from "react";
import Spinner from "../Spinner.js";
import { FcMultipleSmartphones } from "react-icons/fc";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { useDispatch, useSelector } from "react-redux";
import draftToHtml from "draftjs-to-html";
import parse from 'html-react-parser';
import { convertFromRaw, convertToRaw, EditorState } from "draft-js";
import { FaClipboardCheck, FaExpeditedssl, FaMobileScreen, FaQuestion, FaScreenpal, FaUser, FaUserTag } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import moment from 'moment';
import 'moment/locale/es';
import Modal from "../modal/Modal.jsx"
import { Button, Checkbox, IconButton, Tooltip } from "@mui/material";
import { SET_TO_DEFAULT_RESPONSE, create, createCombo } from "../../store/features/slices/ventaSlice.jsx";
import { SET_TO_DEFAULT_RESPONSE as SET_TO_DEFAULT_RESPONSE_SEARCH } from "../../store/features/slices/searchSlice.jsx";
import { MuiTelInput } from "mui-tel-input";
import { SET_CASH_USER } from "../../store/features/slices/userSlice.jsx";
import { MdAutorenew, MdSecurity, MdSyncDisabled } from "react-icons/md";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { UPDATE_LAST10_OF_CATEGORY, UPDATE_LAST10_OF_COMBO, UPDATE_SUBCATEGORY, UPDATE_SUBCATEGORY_BY_COMBO } from "../../store/features/slices/categorySlice.jsx";
import Socket, { authSocket, logoutSocket } from '../../utils/Socket.js';
import CardVip from "../CardVip.jsx";
import { RiShoppingBag4Fill, RiVipCrownFill } from "react-icons/ri";
import { useTranslation } from 'react-i18next';
import DiscountCountdown from "./DiscountCountDown.jsx";
import Switch from "../switch/index.jsx";

const CategoriesCombo = ({ socket, comprarVip }) => {
  const { t } = useTranslation();
  const { userToken, user, userInfo, configuration } = useSelector((state) => state.userReducer);
  const { isMutation: isMutationSearch } = useSelector((state) => state.searchReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    categories,
    combos,
    subcategories,
    isMutation
  } = useSelector((state) => state.categoryReducer);

  const {
    isMutation: isMutationVentaCombo
  } = useSelector((state) => state.ventaReducer);

  const [comboSelector, setComboSelector] = useState({
    open: false, combo_type: "", combo_selected: [], max: 2, sendWhatsappTouser: false, contactoInfo: {
      email: "",
      username: "",
      password: "",
      countrycode: "",
      celular: "",
      alias: ""
    }, acept_terms: false, viewterms: false
  })

  const openComboSelector = (combo_type) => {
    if (combos.find(c => c.name === combo_type && !c.enabled)) {
      return
    }
    let max = 2
    combo_type === 'DUO' ? max = 2 : combo_type === 'TRIO' ? max = 3 : combo_type === 'CUARTETO' ? max = 4 : max = 5
    setComboSelector({ ...comboSelector, combo_type: combo_type, open: !comboSelector.open, max: max })
  }

  const handleSelectSubcategory = (subcat) => {
    if (subcat.stock < 1 && subcat.tipoentrega === true) {
      return
    }

    const isAlreadySelected = comboSelector.combo_selected.find(item => item._id === subcat._id);

    if (isAlreadySelected) {
      // Si ya está seleccionada, la quitamos
      setComboSelector(prev => ({
        ...prev,
        combo_selected: prev.combo_selected.filter(item => item._id !== subcat._id)
      }));
    } else {
      // Si aún no está seleccionada y no ha alcanzado el máximo
      if (comboSelector.combo_selected.length < comboSelector.max) {
        setComboSelector(prev => ({
          ...prev,
          combo_selected: [...prev.combo_selected, subcat]
        }));
      } else {
        message(`Solo puedes seleccionar hasta ${comboSelector.max} servicios.`, 'error', 3);
      }
    }
  };

  const onSubmitCreateCombo = (e) => {
    e.preventDefault()
    if (userToken) {
      if (comboSelector.max !== comboSelector.combo_selected.length) {
        message(`debes seleccionar el combo correctamente`, 'error', 3);
      } else {
        let totalamount = comboSelector.combo_selected.reduce((acc, subcat) => {
          const isVip = userInfo?.vip?.state === 'ACTIVE' &&
            new Date(userInfo?.vip?.expirationdate) > new Date();
          const basePrice = userInfo?.reseller
            ? subcat.costocomboreseller
            : subcat.costocombousuario;
          const descuento = isVip ? (subcat?.discountvip || 0) : 0;
          return acc + ((basePrice || 0) - descuento);
        }, 0)
        dispatch(createCombo({ userId: user?.id, combo: comboSelector.combo_selected, actionTypeAdmin: false, totalamount, contactoInfo: comboSelector.contactoInfo }))
      }
    } else {
      navigate('/login');
    }
  }

  useEffect(() => {
    if (isMutationVentaCombo.successCombo) {
      socket.emit('testeo', 'nuevo mensaje')
      message(isMutationVentaCombo.message, 'success', 5)
      dispatch(SET_CASH_USER({ type: 'DECREASE', amount: isMutationVentaCombo.extra.callback.amount }))
      if (isMutationVentaCombo.extra.callback.tipoentrega) {
        Socket.emit('uCombos', { newData: isMutationVentaCombo.extra.callback.newData, newHistory: isMutationVentaCombo.extra.callback.newComboHistory })
        dispatch(UPDATE_SUBCATEGORY_BY_COMBO({ newData: isMutationVentaCombo.extra.callback.newData }))
      }
      dispatch(UPDATE_LAST10_OF_COMBO(isMutationVentaCombo.extra.callback.newComboHistory))
      dispatch(SET_TO_DEFAULT_RESPONSE())
      navigate('/manage-account/userorders');
    }
  }, [dispatch, isMutationVentaCombo.successCombo])


  var settings = {
    centerMode: true,
    infinite: true,
    centerPadding: "8px",
    slidesToShow: 3,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 2000,
    pauseOnHover: false,
    nextArrow: <></>,
    prevArrow: <></>
  };

  var settings2 = {
    centerMode: true,
    infinite: true,
    centerPadding: "0px",
    slidesToShow: 1,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 2000,
    pauseOnHover: false,
    nextArrow: <></>,
    prevArrow: <></>
  };

  return (

    <>
      <Modal
        open={comboSelector.open}
        onClose={() => setComboSelector({
          ...comboSelector, combo_type: "", open: false, max: 2, combo_selected: [], sendWhatsappTouser: false, contactoInfo: {
            email: "",
            username: "",
            password: "",
            countrycode: "",
            celular: "",
            alias: ""
          }, acept_terms: false, viewterms: false
        })}
        headerTitle={`${t('selectyour')} ${comboSelector.combo_type}`}
        size="base"
      >
        <form className="w-full" onSubmit={onSubmitCreateCombo}>
          <div className="flex flex-wrap relative">
            <div className="w-full text-brand-900 dark:text-brand-200 mt-1">
              <div className="w-full min-h-[22rem] grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-x-2 md:gap-x-5 gap-y-5 md:gap-y-5 mb-4">

                {
                  subcategories.filter((fil) => fil?.enabled && fil?.category?.type === 'Streaming' && fil?.category?.enabled && fil?.minmonths === 1 && !fil?.requiredemail && !fil?.requireduser && !fil?.requiredpassword).map((subcat) => {
                    var discountvip = 0
                    var isVip = false
                    var stockcuentasBoolean = false
                    var stockperfilesBoolean = false
                    var totalstock = subcat.stock ? subcat.stock : 0
                    var price = 100
                    if (subcat.cuentacompleta && totalstock > 0) {
                      stockcuentasBoolean = true
                    }

                    if (!subcat.cuentacompleta && totalstock > 0) {
                      stockperfilesBoolean = true
                    }

                    if (userInfo?.vip?.state === 'ACTIVE' && new Date(userInfo?.vip?.expirationdate) > new Date()) {
                      isVip = true
                      discountvip = subcat?.discountvip
                    }

                    if (userInfo?.reseller) {
                      price = subcat?.costocomboreseller - discountvip
                    } else {
                      price = subcat?.costocombousuario - discountvip
                    }

                    const isSelected = comboSelector.combo_selected.find(item => item._id === subcat._id);

                    return (
                      <div
                        key={subcat._id}
                        onClick={() => handleSelectSubcategory(subcat)}
                        className={`relative w-full rounded-2xl p-2 transition-all duration-300 cursor-pointer group border-2 
      ${isSelected ? 'border-green-400 bg-green-200/30 dark:bg-green-800/30 shadow-lg' : 'border-transparent bg-black/5 dark:bg-white/5'} 
      ${totalstock < 1 && subcat.tipoentrega ? 'grayscale-[100%] opacity-60' : ''}
    `}
                      >
                        <div className="w-full flex items-center justify-center mb-4">
                          <LazyLoadImage
                            className="w-16 h-16 rounded-full object-cover shadow-md"
                            alt={`No image ${subcat.name}`}
                            effect="blur"
                            src={`/images/logos/${subcat.logo}`}
                          />
                        </div>

                        <div className="text-xs h-[40px] font-semibold text-center text-brand-900 dark:text-white mb-2 custom-truncate">
                          {subcat.name}
                        </div>

                        <div className="flex justify-center mb-3">
                          <div className={`text-sm font-semibold px-3 py-1 rounded-full shadow 
        ${userInfo?.reseller ? 'bg-amber-400/30 text-amber-700 dark:text-amber-200' : 'bg-green-400/30 text-green-700 dark:text-green-200'}
      `}>
                            {currencyFormat(price)}
                          </div>
                        </div>

                        <div className="text-[10px] font-medium text-center uppercase">
                          {
                            subcat.tipoentrega ? (
                              totalstock > 0 ? (
                                <span className="text-green-600 dark:text-green-400">
                                  {t('stock')}: <span className="font-bold text-lg">{totalstock}</span>
                                </span>
                              ) : (
                                <span className="text-red-600 dark:text-red-400">
                                  {t('wostock')}
                                </span>
                              )
                            ) : (
                              <span className="text-green-600 dark:text-green-400">
                                {t('stock')}: <span className="font-bold text-lg">10</span>
                              </span>
                            )
                          }
                        </div>

                        {isSelected && (
                          <div className="absolute top-2 right-2 bg-green-500 text-white rounded-full p-1">
                            <FaClipboardCheck size={14} />
                          </div>
                        )}
                      </div>
                    )
                  })
                }
              </div>

              <div
                className={`w-full mt-6 rounded-2xl p-4 shadow-xl border transition-all duration-300
    ${comboSelector.combo_type === 'DUO'
                    ? 'bg-gradient-to-br from-white dark:from-black via-red-200 to-red-300 border-red-300 dark:via-red-800 dark:to-red-900 dark:border-red-700'
                    : comboSelector.combo_type === 'TRIO'
                      ? 'bg-gradient-to-br from-white dark:from-black via-green-200 to-green-300 border-green-300 dark:via-green-800 dark:to-green-900 dark:border-green-700'
                      : comboSelector.combo_type === 'CUARTETO'
                        ? 'bg-gradient-to-br from-white dark:from-black via-blue-200 to-blue-300 border-blue-300 dark:via-blue-800 dark:to-blue-900 dark:border-blue-700'
                        : comboSelector.combo_type === 'QUINTETO'
                          ? 'bg-gradient-to-br from-white dark:from-black via-purple-200 to-purple-300 border-purple-300 dark:via-purple-800 dark:to-purple-900 dark:border-purple-700'
                          : 'bg-gradient-to-br from-white dark:from-black via-neutral-200 to-brand-100 border-brand-200 dark:via-brand-800 dark:to-brand-900 dark:border-brand-700'
                  }`}
              >
                <h3 className="text-lg font-bold text-brand-800 dark:text-brand-200 mb-4 text-center">Resumen de tu {comboSelector.combo_type}</h3>

                <div className={`grid grid-cols-1 ${(configuration?.vip?.vip1?.enabled || configuration?.vip?.vip2?.enabled || configuration?.vip?.vip3?.enabled) ? 'sm:grid-cols-2' : 'sm:grid-cols-3'} gap-4 text-center`}>
                  {/* Subcategorías seleccionadas con logos */}
                  <div className="bg-white/60 dark:bg-white/10 backdrop-blur rounded-xl p-3 shadow flex flex-col items-center">
                    <p className="text-xs text-brand-700 dark:text-brand-300 mb-2">Servicios</p>
                    <div className="flex -space-x-3 overflow-hidden p-2">
                      {comboSelector.combo_selected.map((subcat, index) => (
                        <LazyLoadImage
                          key={index}
                          src={`/images/logos/${subcat.logo}`}
                          effect="blur"
                          className="inline-block h-10 w-10 rounded-full ring-2 ring-white dark:ring-brand-800 object-cover"
                          alt={subcat.name}
                        />
                      ))}
                    </div>
                  </div>


                  {/* Total ahorro VIP (condicional y con validación de configuración) */}
                  {(configuration?.vip?.vip1?.enabled || configuration?.vip?.vip2?.enabled || configuration?.vip?.vip3?.enabled) && (
                    <div className="bg-white/60 dark:bg-white/10 backdrop-blur rounded-xl p-4 shadow">
                      {userInfo?.vip?.state === 'ACTIVE' &&
                        new Date(userInfo?.vip?.expirationdate) > new Date() ? (
                        <>
                          <p className="text-sm text-brand-700 dark:text-brand-300 mb-1">Estás ahorrando con VIP</p>
                          <p className="text-2xl font-bold text-amber-500">
                            {currencyFormat(
                              comboSelector.combo_selected.reduce((acc, subcat) => acc + (subcat?.discountvip || 0), 0)
                            )}
                          </p>
                          <p className="text-xs text-brand-600 dark:text-brand-400 mt-1">Gracias a tu membresía activa</p>
                        </>
                      ) : (
                        <>
                          <p className="text-sm text-brand-700 dark:text-brand-300 mb-1">Ahorro potencial con VIP</p>
                          <p className="text-2xl font-bold text-amber-500">
                            {currencyFormat(
                              comboSelector.combo_selected.reduce((acc, subcat) => acc + (subcat?.discountvip || 0), 0)
                            )}
                          </p>
                          <p className="text-xs text-brand-600 dark:text-brand-400 mt-1">Activa VIP para obtener este ahorro</p>
                        </>
                      )}
                    </div>
                  )}

                  {/* Bloque tipo de entrega */}

                  <div className="bg-white/60 dark:bg-white/10 backdrop-blur rounded-xl p-3 shadow grid items-center content-center">
                    <p className="text-xs text-brand-700 dark:text-brand-300 mb-1">Entrega</p>
                    {comboSelector.combo_selected.length > 0 && (<>
                      <span className={`inline-block w-2 h-2 rounded-full ${comboSelector.combo_selected.every(subcat => subcat?.tipoentrega === true)
                        ? 'bg-green-500'
                        : 'bg-yellow-500'
                        } animate-pulse`}></span>
                      <p className="text-sm font-medium text-gray-800 dark:text-gray-200">
                        {
                          comboSelector.combo_selected.every(subcat => subcat?.tipoentrega === true)
                            ? t('orderauto')
                            : t('delivered30')
                        }
                      </p>
                    </>)}
                  </div>



                  {/* Total con descuento aplicado */}
                  <div className="bg-white/60 dark:bg-white/10 backdrop-blur rounded-xl p-3 shadow grid items-center content-center">
                    <p className="text-xs text-brand-700 dark:text-brand-300 mb-1">{t('totalforpay')}</p>
                    <p className="text-xl font-semibold text-green-600 dark:text-green-400">
                      {currencyFormat(
                        comboSelector.combo_selected.reduce((acc, subcat) => {
                          const isVip = userInfo?.vip?.state === 'ACTIVE' &&
                            new Date(userInfo?.vip?.expirationdate) > new Date();
                          const basePrice = userInfo?.reseller
                            ? subcat.costocomboreseller
                            : subcat.costocombousuario;
                          const descuento = isVip ? (subcat?.discountvip || 0) : 0;
                          return acc + ((basePrice || 0) - descuento);
                        }, 0)
                      )}
                    </p>
                  </div>
                </div>
              </div>

              <div className="space-y-6 mt-5">
                {userInfo?.reseller && (
                  <>
                    {/* INFORMACIÓN GENERAL DEL ENVÍO */}
                    <div className={`w-full mt-6 rounded-2xl p-4 shadow-xl border transition-all duration-300
    ${comboSelector.combo_type === 'DUO'
                        ? 'bg-gradient-to-br from-white dark:from-black via-red-200 to-red-300 border-red-300 dark:via-red-800 dark:to-red-900 dark:border-red-700'
                        : comboSelector.combo_type === 'TRIO'
                          ? 'bg-gradient-to-br from-white dark:from-black via-green-200 to-green-300 border-green-300 dark:via-green-800 dark:to-green-900 dark:border-green-700'
                          : comboSelector.combo_type === 'CUARTETO'
                            ? 'bg-gradient-to-br from-white dark:from-black via-blue-200 to-blue-300 border-blue-300 dark:via-blue-800 dark:to-blue-900 dark:border-blue-700'
                            : comboSelector.combo_type === 'QUINTETO'
                              ? 'bg-gradient-to-br from-white dark:from-black via-purple-200 to-purple-300 border-purple-300 dark:via-purple-800 dark:to-purple-900 dark:border-purple-700'
                              : 'bg-gradient-to-br from-white dark:from-black via-neutral-200 to-brand-100 border-brand-200 dark:via-brand-800 dark:to-brand-900 dark:border-brand-700'
                      }`}>
                      <h3 className="text-black dark:text-white text-lg font-bold flex items-center mb-3">
                        {t('sendbywhatsapp')}
                        <Tooltip
                          title={
                            <div>
                              <div className="w-full mb-2 text-center font-semibold border-b-2 border-white">{t('sendorderbywhatsapp')}</div>
                              <div className="text-sm font-normal text-brand-300 dark:text-brand-300">{t('orderdetailtoclient')}</div>
                            </div>
                          }
                          PopperProps={{
                            sx: {
                              "& .MuiTooltip-tooltip": {
                                fontSize: 12.5,
                                backgroundColor: comboSelector.color || '#4f46e5',
                                color: "#fff",
                              },
                            },
                          }}
                          arrow
                        >
                          <IconButton className="ml-3 w-10 h-10 rounded-full bg-white/30 text-white hover:scale-105 transition">
                            <FaQuestion size={20} className="text-lightPrimary dark:darkPrimary" />
                          </IconButton>
                        </Tooltip>
                      </h3>

                      <div className="flex items-center justify-between">
                        <div className="text-black/70 dark:text-white/70  text-sm md:text-base font-medium max-w-[85%]">
                          <span className="block">{t('enablewhatsapptoclient')}</span>
                          <span className="block text-xs text-black/70 dark:text-white/70 mt-1">
                            {t('enablewhatsappdescription')}
                          </span>
                        </div>

                        <Switch
                          checked={comboSelector.sendWhatsappTouser}
                          onChange={() =>
                            setComboSelector({ ...comboSelector, sendWhatsappTouser: !comboSelector.sendWhatsappTouser })
                          }
                        />
                      </div>
                    </div>
                  </>
                )}

                {comboSelector.sendWhatsappTouser && (
                  <div className={`w-full mt-6 rounded-2xl p-4 shadow-xl border transition-all duration-300
                ${comboSelector.combo_type === 'DUO'
                      ? 'bg-gradient-to-br from-white dark:from-black via-red-200 to-red-300 border-red-300 dark:via-red-800 dark:to-red-900 dark:border-red-700'
                      : comboSelector.combo_type === 'TRIO'
                        ? 'bg-gradient-to-br from-white dark:from-black via-green-200 to-green-300 border-green-300 dark:via-green-800 dark:to-green-900 dark:border-green-700'
                        : comboSelector.combo_type === 'CUARTETO'
                          ? 'bg-gradient-to-br from-white dark:from-black via-blue-200 to-blue-300 border-blue-300 dark:via-blue-800 dark:to-blue-900 dark:border-blue-700'
                          : comboSelector.combo_type === 'QUINTETO'
                            ? 'bg-gradient-to-br from-white dark:from-black via-purple-200 to-purple-300 border-purple-300 dark:via-purple-800 dark:to-purple-900 dark:border-purple-700'
                            : 'bg-gradient-to-br from-white dark:from-black via-neutral-200 to-brand-100 border-brand-200 dark:via-brand-800 dark:to-brand-900 dark:border-brand-700'
                    }`}>
                    <div className="flex items-center justify-between border-b border-brand-200 dark:border-brand-900 pb-2">
                      <h3 className="text-lg font-bold text-black dark:text-white flex items-center">
                        {t('clientinfo')}
                        <Tooltip
                          title={
                            <div>
                              <div className="w-full mb-2 text-center font-semibold border-b-2 border-brand-600">
                                {t('forreseller')}
                              </div>
                              <div className="text-brand-300 dark:text-brand-300 text-sm font-normal">
                                {t('forresellerdetails')}
                              </div>
                            </div>
                          }
                          PopperProps={{
                            sx: {
                              "& .MuiTooltip-tooltip": {
                                fontSize: 12.5,
                              },
                            },
                          }}
                          arrow
                        >
                          <IconButton className="ml-3 w-10 h-10 rounded-full bg-brand-800 text-white hover:scale-105 transition">
                            <FaQuestion size={20} className="text-lightPrimary dark:darkPrimary" />
                          </IconButton>
                        </Tooltip>
                      </h3>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-5">
                      <div>
                        <label className="block mb-2 text-sm font-medium text-brand-900 dark:text-white">
                          {t('phonenumber')}{' '}
                          <span className="text-xs text-red-600 dark:text-red-400">({t('required')})</span>
                        </label>
                        <MuiTelInput
                          required={comboSelector.sendWhatsappTouser}
                          className="custom-style-input"
                          helperText={t('whatsappreal')}
                          inputProps={{ className: "text-brand-900 dark:text-brand-200" }}
                          value={comboSelector.contactoInfo.celular}
                          defaultCountry={'PE'}
                          onChange={(newValue, info) =>
                            setComboSelector({
                              ...comboSelector,
                              contactoInfo: {
                                ...comboSelector.contactoInfo,
                                countrycode: info.countryCode,
                                celular: newValue,
                              },
                            })
                          }
                        />
                      </div>

                      <div>
                        <label className="block mb-2 text-sm font-medium text-brand-900 dark:text-white">
                          Alias <span className="text-xs text-red-600 dark:text-red-400">({t('required')})</span>
                        </label>
                        <input
                          type="text"
                          maxLength={20}
                          autoComplete="off"
                          required={comboSelector.sendWhatsappTouser}
                          className="custom-style-input"
                          value={comboSelector.contactoInfo.alias}
                          onChange={(e) =>
                            setComboSelector({
                              ...comboSelector,
                              contactoInfo: {
                                ...comboSelector.contactoInfo,
                                alias: e.target.value,
                              },
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="relative mt-8">
                <label className="text-brand-900 dark:text-brand-200">{t('termsandconditions')}</label>
                <div class="flex items-center">
                  <Checkbox
                    checked={comboSelector.acept_terms ? true : false}
                    onClick={() => setComboSelector({ ...comboSelector, acept_terms: !comboSelector.acept_terms })}
                    sx={{ '& .MuiSvgIcon-root': { fontSize: 28, color: '#00008b' } }}
                  />
                  {!comboSelector.acept_terms && <span class="animate-ping absolute inline-flex h-8 w-8 rounded-full bg-blue-500 left-2"></span>}
                  <label for="link-checkbox" class="ml-1 text-sm font-medium text-brand-900 dark:text-brand-300">{t('agree1')}
                    <a href="#" onClick={() => setComboSelector({ ...comboSelector, viewterms: !comboSelector.viewterms })} class="text-blue-600 hover:text-blue-500"> {t('agree2')}</a>.</label>

                </div>
                <Modal
                  open={comboSelector.viewterms}
                  onClose={() => setComboSelector({ ...comboSelector, viewterms: false })}
                  headerTitle={t('agree3')}
                  size="base"
                >
                  <div className={`h-auto text-brand-900 dark:text-brand-200 relative transition-all duration-500 ease-in-out`}>
                    <h3 className="font-bold w-full text-2xl">🔔 {t('agreeimportant')} :</h3>
                    <div className="text-[13px] mt-2 font-semibold">
                      {t('comboterms')}
                    </div>
                  </div>
                </Modal>
              </div>


              <div className="w-full mt-5 mb-8 sm:mb-2">
                <Button disabled={(comboSelector.combo_selected.length === comboSelector.max && comboSelector.acept_terms) ? false : true}
                  sx={{
                    "&.Mui-disabled": {
                      background: !"#525252",
                      color: "#a3a3a3"
                    }
                  }}
                  type="submit" style={{ width: '100%', height: 65, marginLeft: 'auto', marginRight: 'auto' }}
                  size='large' variant="contained" color="primary" startIcon={(isMutationVentaCombo.loading) ? <Spinner w={'35px'} h={'35px'} /> : <IoCart size={24} className="mr-2" />}>{isMutationVentaCombo.loading ? t('proccessing') : t('pay') + ' ' + currencyFormat(comboSelector.combo_selected.reduce((acc, subcat) => {
                    const isVip = userInfo?.vip?.state === 'ACTIVE' &&
                      new Date(userInfo?.vip?.expirationdate) > new Date();
                    const basePrice = userInfo?.reseller
                      ? subcat.costocomboreseller
                      : subcat.costocombousuario;
                    const descuento = isVip ? (subcat?.discountvip || 0) : 0;
                    return acc + ((basePrice || 0) - descuento);
                  }, 0))} </Button>
              </div>

            </div>
          </div>
        </form>
      </Modal >

      {
        !isMutation.loading && combos.some(com => com?.enabled) &&
        <>
          <div style={{ fontFamily: 'Outfit, sans-serif' }} className="w-full 
       text-brand-900 dark:text-brand-100
        mb-3 mt-4 md:mt0 text-center text-lg md:text-xl pt-5 pb-5 md:pt-14 md:pb-14 contrast-[125%]">
            <div style={{ fontFamily: 'Outfit, sans-serif' }} className="uppercase">{t('services')}</div>
            <div className="text-4xl md:text-6xl bg-gradient-to-t from-brand-800 to-purple-500 inline-block text-transparent bg-clip-text">
              COMBOS
            </div>
          </div>
          <div>
          </div>

          <div className="flex flex-wrap w-full pb-10">
            <div className="w-full min-h-[22rem] grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 md:gap-x-8 gap-y-8 md:gap-y-14">

              {[
                { tipo: 'DUO', shadow: 'shadow-red-300', hoverBorder: 'hover:border-red-400', hoverRingBorder: 'hover:ring-4 hover:ring-red-300/60', darkHoverRingBorder: 'dark:hover:ring-red-500/50', color: 'red', text: 'text-red-600', darkText: 'dark:text-red-300' },
                { tipo: 'TRIO', shadow: 'shadow-green-300', hoverBorder: 'hover:border-green-400', hoverRingBorder: 'hover:ring-4 hover:ring-green-300/60', darkHoverRingBorder: 'dark:hover:ring-green-500/50', color: 'green', text: 'text-green-600', darkText: 'dark:text-green-300' },
                { tipo: 'CUARTETO', shadow: 'shadow-blue-300', hoverBorder: 'hover:border-blue-400', hoverRingBorder: 'hover:ring-4 hover:ring-blue-300/60', darkHoverRingBorder: 'dark:hover:ring-blue-500/50', color: 'blue', text: 'text-blue-600', darkText: 'dark:text-blue-300' },
                { tipo: 'QUINTETO', shadow: 'shadow-purple-300', hoverBorder: 'hover:border-purple-400', hoverRingBorder: 'hover:ring-4 hover:ring-purple-300/60', darkHoverRingBorder: 'dark:hover:ring-purple-500/50', color: 'purple', text: 'text-purple-600', darkText: 'dark:text-purple-300' },
              ].map(({ tipo, shadow, hoverBorder, hoverRingBorder, darkHoverRingBorder, color, text, darkText }) => (
                <div
                  key={tipo}
                  onClick={() => openComboSelector(tipo)}
                  className={`${combos.find(c => c.name === tipo && !c.enabled) ? 'grayscale-[100%] opacity-60' : 'shadow-lg group '} relative bg-white dark:bg-brand-950 dark:shadow-black min-h-[300px] h-[300px] md:h-[310px] lg:h-[320px] overflow-hidden rounded-2xl transition-transform ease-in-out duration-700 md:hover:scale-[115%] cursor-pointer`}
                >
                  {/* Fondo decorativo blur */}
                  <div className="absolute w-72 h-48 blur-[50px] -right-1/2 -bottom-1/2" style={{ backgroundColor: color }}></div>
                  {/* Contenido */}
                  <LazyLoadImage
                    src={`/images/logos/combo-${tipo}.webp`}
                    className="h-[calc(100%-4rem)] w-[calc(100%-2px)] absolute top-0 z-5"
                    alt={`Fondo ${tipo}`}
                  />
                  <div className="relative h-[calc(100%-4.9rem)] flex items-center justify-center z-10">
                    <h3 className={`text-2xl font-bold ${text} ${darkText}`}></h3>
                  </div>
                  <div class="relative w-full h-[4.2rem] z-5 flex items-center justify-center bg-white dark:bg-brand-950">
                    {
                      !isMutation.loading && combos.find(c => c.name === tipo)?.history?.length > 3 &&
                      <div className="flex flex-wrap justify-center w-full">
                        <Slider className="!relative overflow-hidden !rounded-l-full !rounded-r-lg max-w-[95px] min-w-[95px] max-h-[2.5rem] min-h-[2.5rem] z-20" key={tipo} {...settings}>
                          {
                            !isMutation.loading &&
                            [...combos.find(c => c.name === tipo)?.history || []]
                              .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                              .map((item) => {
                                return (
                                  <>
                                    {
                                      item?.user?.photo === 'unknowphoto.webp' ?
                                        <div style={{ background: `${generateBackgroundColor(item?.user?.name)}` }} className="uppercase -ml-[8px] relative mr-4 size-[2.5rem] rounded-full flex items-center justify-center text-white text-xl font-bold border-2 border-white dark:border-brand-900 z-10" key={item._id}>
                                          {item?.user?.name.substr(0, 1)}
                                        </div>
                                        :
                                        <div className="-ml-[8px] overflow-hidden z-10 relative mr-4 size-[2.5rem] rounded-full flex items-center justify-center" key={tipo}>
                                          <LazyLoadImage
                                            className="object-cover size-[2.5rem] rounded-full border-2 border-white dark:border-brand-900 z-10"
                                            alt={`No image ${item?.user?.name}`}
                                            effect="blur"
                                            src={`/images/photos/${item?.user?.photo}`}
                                          />
                                        </div>
                                    }
                                  </>
                                )
                              })
                          }
                        </Slider>
                        {
                          !isMutation.loading && combos.find(c => c.name === tipo)?.history?.length > 0 &&
                          <div className="-ml-[17px] z-30 relative size-[2.5rem] rounded-full border-2 border-white dark:border-brand-900 z-10 flex items-center justify-center bg-brand-900 dark:bg-brand-50">
                            <FaUser size={22} className="text-brand-50 dark:text-brand-900" />
                          </div>
                        }

                        <Slider className="w-[calc(95%)] z-20 !m-auto h-[20px]" key={tipo} {...settings2}>
                          {
                            !isMutation.loading &&
                            [...combos.find(c => c.name === tipo)?.history || []]
                              .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                              .map((item) => {
                                return (
                                  <div className="relative text-[9px] font-normal text-center text-black dark:text-white px-1 overflow-hidden truncate" key={item._id}>
                                    {sensurarEmail(item?.user?.email ? item?.user?.email : 'unknow@unknow.com')} {moment(item?.created_at).fromNow()}
                                  </div>)
                              })
                          }
                        </Slider>
                      </div>
                    }
                  </div>
                </div>
              ))}

            </div>
          </div>
        </>
      }
    </>
  );
};

export default CategoriesCombo;